export default function RenderIf({ condition, children, elseRender = null }) {
  return condition ? children : elseRender
}
